import { realBricksApi } from '../../utils/axiosInterceptors';
import { toastNotify } from '../../utils/toastNotify';

export const getAccountStatus = async (data, { rejectWithValue }) => {
  const { onFail = () => {}, onSuccess = () => {} } = data;
  try {
    const response = await realBricksApi.get(`/api/v1/user/account-status`);
    onSuccess()
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const deactivateAccount = async (data, { rejectWithValue }) => {
    const { onFail = () => {}, onSuccess = () => {} } = data;
    try {
      const response = await realBricksApi.delete(`/api/v1/user/deactivate-account`);
      onSuccess(
        toastNotify('success', response?.data?.message)
      )
      return response.data;
    } catch (err) {
      onFail();
      return rejectWithValue(err?.response?.data?.message);
    }
  };

export const accountReactivationLink = async (data, { rejectWithValue }) => {
    const { onFail = () => {}, onSuccess = () => {} } = data;
    try {
      const response = await realBricksApi.post(`/api/v1/user/account-reactivation-link`);
      onSuccess()
      return response.data;
    } catch (err) {
      onFail();
      return rejectWithValue(err?.response?.data?.message);
    }
  };


  